import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { getErrorDetails } from "@fyrstain/hl7-front-library";

/** Provides a safe error route for fetch/FHIR callbacks, including callbacks without an error argument. */
export function useErrorNavigation(): (error?: unknown) => void {
  const navigate = useNavigate();

  return useCallback(
    (error?: unknown) => {
      navigate("/Error", { state: { error: getErrorDetails(error) } });
    },
    [navigate]
  );
}
